module.exports = __webpack_public_path__ + "media/images/story/icon/question-icon-3fa1b11da4999afad11c8899716cef83.png";